'use client';

import Script from 'next/script';
import { CONTACT, services } from '@/content/offers';

export default function SchemaOrg() {
  const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://gauthier-rodriguez.fr';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Gauthier Rodriguez',
    description: 'Développeur web freelance spécialisé en création de sites vitrines modernes, applications web sur-mesure et identité visuelle.',
    url: baseUrl,
    image: `${baseUrl}/opengraph-image`,
    logo: `${baseUrl}/assets/img/logo.svg`,
    founder: {
      '@type': 'Person',
      name: 'Gauthier Rodriguez',
      jobTitle: 'Développeur Web Full-Stack',
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'FR',
      addressLocality: 'Toulouse',
      addressRegion: 'Occitanie',
      postalCode: '31000',
    },
    sameAs: [CONTACT.linkedin],
    priceRange: '€€',
    areaServed: {
      '@type': 'Country',
      name: 'France',
    },
    serviceType: ['Création de sites web', 'Développement d\'applications web', 'Identité visuelle', 'Logo professionnel'],
    // Offres et prix « à partir de », tirés de src/content/offers.ts
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Services',
      itemListElement: services.map((service) => ({
        '@type': 'OfferCatalog',
        name: service.title,
        url: `${baseUrl}/services/${service.slug}`,
        itemListElement: service.plans.map((plan) => ({
          '@type': 'Offer',
          name: plan.name,
          description: plan.description,
          priceSpecification: {
            '@type': 'PriceSpecification',
            minPrice: plan.from,
            priceCurrency: 'EUR',
            ...(plan.period ? { unitText: 'MONTH' } : {}),
          },
        })),
      })),
    },
  };

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Gauthier Rodriguez',
    alternateName: ['Gauthier RODRIGUEZ', 'G. Rodriguez'],
    givenName: 'Gauthier',
    familyName: 'Rodriguez',
    jobTitle: 'Développeur Web Freelance Full-Stack',
    url: baseUrl,
    image: `${baseUrl}/opengraph-image`,
    description: 'Gauthier Rodriguez est un développeur web freelance et graphiste basé à Toulouse, expert en React, Next.js et TypeScript. Spécialisé dans la création de sites vitrines, applications web et identité visuelle.',
    email: 'bonjour@gauthier-rodriguez.fr',
    telephone: '+33630267833',
    knowsAbout: [
      'React',
      'Next.js',
      'TypeScript',
      'JavaScript',
      'Node.js',
      'Tailwind CSS',
      'Web Development',
      'Full-Stack Development',
      'UI/UX Design',
      'SEO',
      'Responsive Design',
    ],
    sameAs: [CONTACT.linkedin],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Gauthier Rodriguez - Développeur Web Freelance',
    url: baseUrl,
    description: 'Portfolio et services de développement web freelance',
    publisher: {
      '@type': 'Person',
      name: 'Gauthier Rodriguez',
    },
  };

  return (
    <>
      <Script
        id="schema-organization"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema),
        }}
      />
      <Script
        id="schema-person"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(personSchema),
        }}
      />
      <Script
        id="schema-website"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema),
        }}
      />
    </>
  );
}
